import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mobile-card-header hide-desktop" }
const _hoisted_2 = {
  key: 0,
  class: "label_pending label_pending__danger"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "label label_danger" }, " Pending Deletion ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-circle" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "label_pending"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "label label_blue" }, " Pending Approval ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-circle" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "label_pending"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", { class: "label label_blue" }, " Pending Address Change ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-circle" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "action-buttons"
}
const _hoisted_15 = {
  key: 0,
  class: "bordered-card-rows-wrapper"
}
const _hoisted_16 = { class: "bordered-card-rows" }
const _hoisted_17 = {
  key: 0,
  class: "divider"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-trash" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "bordered-card-rows" }
const _hoisted_21 = { class: "bordered-card-row" }
const _hoisted_22 = {
  key: 0,
  class: "divider"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-trash" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-edit" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bordered-card-wrapper', _ctx.customClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
      (_ctx.beneficiary?.Additional?.PendingDeletion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : (_ctx.beneficiary?.Additional?.PendingBene)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : (_ctx.beneficiary?.Additional?.PendingChange)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : _createCommentVNode("", true),
      (_ctx.actionButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("i", {
              class: "iatse-icon-edit plan-modal",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('add-beneficiary', 'Edit Beneficiary', 'plan-form plan-upload')), ["prevent"]))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.mode === 'single')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "bordered-card-row"
              }, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.capitalize(key)), 1),
                _createElementVNode("h4", null, _toDisplayString(item), 1),
                (_ctx.hasDivider && key !== Object.keys(item).length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (_ctx.deleteItem)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "delete-item plan-modal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('success-modal', null, 'modal-success', null, _ctx.modalProps)), ["prevent"]))
              }, _hoisted_19))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "bordered-card-rows-wrapper"
          }, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (value, key, keyIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.capitalize(key)), 1),
                    _createElementVNode("h4", null, _toDisplayString(value), 1)
                  ]),
                  (_ctx.hasDivider && keyIndex !== Object.keys(item).length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            (_ctx.addItem)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(['plan-modal btn', _ctx.isAdded(index) && !_ctx.discard ? 'btn-secondary' : 'btn-primary']),
                  onClick: _withModifiers(($event: any) => (_ctx.handleAdd(index)), ["prevent"])
                }, _toDisplayString(_ctx.isAdded(index) && !_ctx.discard ? 'Edit Beneficiary' : 'Add as Beneficiary'), 11, _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.deleteItem)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "delete-item plan-modal",
                  onClick: _withModifiers(($event: any) => (_ctx.removeItem(index)), ["prevent"])
                }, _hoisted_26, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.deleteItem)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "edit-item plan-modal",
                  onClick: _withModifiers(($event: any) => (_ctx.editItem(index)), ["prevent"])
                }, _hoisted_29, 8, _hoisted_27))
              : _createCommentVNode("", true)
          ]))
        }), 128))
  ], 2))
}